module.exports = __webpack_public_path__ + "static/media/brand-info-3.126e5c38.png";